import * as types from './mutation_types'

export default {
  [types.AUTH_REQUEST] (state, error) {
    state.status = 'loading'
  },

  [types.AUTH_SUCCESS] (state, { token, user }) {
    state.status = 'success'
    state.token = token
    state.user = user
    state.expireDate = user.exp
  },

  [types.USER_ROLE] (state, userRole) {
    state.userRole = userRole[0]
  },

  [types.USER_SOCIETE_ID] (state, id) {
    state.userSocieteId = id
  },

  [types.USER_ID] (state, id) {
    state.userId = id
  },

  [types.AUTH_ERROR] (state) {
    state.status = 'error'
  },

  [types.SET_FIRSTNAME] (state, value) {
    state.firstName = value
  },
  [types.SET_NAME] (state, value) {
    state.name = value
  },
  [types.SET_SOCIETENOM] (state, value) {
    state.societeNom = value
  },

  [types.LOGOUT] (state) {
    state.status = ''
    state.token = ''
    state.userRole = ''
    state.userSocieteId = ''
    state.userId = ''
    state.expireDate = 0
  },
  [types.SOCIETE_LISTES] (state, value) {
    state.societeLists = value
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/login/mutations.js